import { call, cancel, cancelled, fork, put, take } from 'redux-saga/effects'

import { APP_NAME } from '../../app/constants'
import { getAvatar } from '../../features/avatar/avatarSlice'
import { getBalance } from '../../features/balance/balanceSlice'
import { getCollection } from '../../features/collection/collectionSlice'
import { getUserCollection } from '../../features/collection/userCollectionSlice'
import { getLeaderboard } from '../../features/leaderboard/leaderboardSlice'
import { getShopItems } from '../../features/shopItems/shopItemsSlice'
import { getEpoch } from '../../features/staking/epochSlice'
import { setUser } from '../../features/user/userSlice'
import { getProfile } from '../../features/userprofile/profileSlice'
import Wallets from '../../ual/wallets'

export function anchorAPI() {
  return new Promise(async (resolve, reject) => {
    try {
      const users = await Wallets.getWallet().loginUser(
        Wallets.getAnchor(),
        APP_NAME,
      )
      console.log('users', users)
      resolve(users)
    } catch (error) {
      console.log(error)
      reject(error)
    }
  })
}

export function* resolveLogin() {
  yield put(getCollection())
  try {
    const identity = yield call(anchorAPI)
    yield put(
      setUser({
        type: 'LOGIN_SUCCESS',
        userAccount: identity[0],
        isWax: false,
        isAnchor: true,
      }),
    )
    yield put(getEpoch())
    yield put(getUserCollection())
    yield put(getLeaderboard())
    yield put(getAvatar())
    yield put(getProfile())
    yield put(getBalance())
    yield put(getShopItems())
  } catch (error) {
    const errorMsg = error.toString()
    yield put(setUser({ type: 'LOGIN_ERROR', error: errorMsg }))
  } finally {
    if (yield cancelled()) {
      yield put(setUser({ type: 'LOGIN_CANCELLED' }))
    }
  }
}

export function* loginFlow() {
  while (true) {
    yield put(setUser({ type: 'GET_ANCHOR_USER' }))
    const task = yield fork(resolveLogin)
    const action = yield take(['LOGOUT', 'LOGIN_ERROR'])
    if (action.type === 'LOGOUT') {
      yield cancel(task)
    }
  }
}